import React from "react";

const About = () => {
  const sections = [
    {
      name: "Dr. S. Arulrhaj",
      image: "url(/arhulraj.png)",
      title: "Dr. S. Arulrhaj",
      subtitle: "Chairman",
      bio: "Dr. S. Arulrhaj is a highly esteemed medical professional with over 42 years of distinguished service as a Senior Physician, specializing in cardiology and intensive care. A gold medallist in MD (Medicine), he has been a pioneering force in the healthcare sector, contributing to medical education, clinical excellence, and global health leadership. He currently serves as the President of the Commonwealth Medical Association and President-Elect of the Association of Physicians of India (API). His extensive contributions to the medical community include founding and leading esteemed institutions such as the Commonwealth Medical Association Trust (UK), Commonwealth Medical eVarsity, and the Indo Global Cardio Diabetes Academy. Dr. Arulrhaj has held prestigious positions, including Past President of the Commonwealth Medical Association (UK), Past National President of the Indian Medical Association (IMA), and Founder & Past Chairman of the Commonwealth Health Professions Alliance (UK). His commitment to advancing medical knowledge is further reflected in his roles as Honorary Professor at IMA and Adjunct Professor of Medicine at Dr. MGR Medical University, Chennai. As the Chairman & Head of Acute Medicine at Sundaram Arulrhaj Hospitals and the Founder & Chairman of the Aruls Groups, Dr. Arulrhaj remains dedicated to delivering excellence in patient care, medical research, and healthcare education. His legacy continues through the Dr. S. Arulrhaj Health Education & Research Foundation, fostering innovation and excellence in medical practice.",
    },
    {
      name: "Mr. Rajanikant M. Torgal",
      image: "url(/rajanikant.png)",
      title: "Rajanikant M. Torgal",
      subtitle: "Founder & CEO",
      bio: "Rajanikant M. Torgal is the visionary Founder & CEO of LifeOnPlus, a groundbreaking digital health ecosystem designed to transform preventive and non-invasive healthcare in India and beyond. With over three decades of experience across telecommunications, AI, and health technology, Mr. Torgal has emerged as a pioneering force in the HealthTech sector. His mission is to bridge global healthcare gaps through innovation, affordability, and accessibility. From leading mobile technology ventures to launching India's first integrated Smart Health Card and Body Recharge Station, Rajanikant Torgal's journey reflects a relentless commitment to empowering lives through intelligent healthcare. Today, he stands at the forefront of a global movement to redefine how the world experiences wellness and digital health.",
    },
    {
      name: "Mr. Peter Yeo",
      image: "url(/peter.png)",
      title: "Mr. Peter Yeo",
      subtitle: "Chief Marketing Officer",
      bio: "Mr. Peter Yeo is a seasoned marketing professional with over 40 years of diverse industry experience, specializing in consumer and semiconductor marketing. A qualified Marine Engineer by profession, he later transitioned into marketing, bringing a unique blend of technical expertise and strategic business acumen. With 10 years in consumer marketing and 30 years in semiconductor marketing, Mr. Yeo has gained extensive international and regional exposure across Europe and the Asia-Pacific region. He has held top management positions in both MNCs and SMEs, leading global marketing strategies, managing key accounts, and driving business growth on an international scale. A graduate of Curtin University of Technology with a Bachelor’s degree in Commerce, he possesses deep expertise in global marketing, strategic brand positioning, and high-value client management. His leadership and industry insights continue to shape innovative marketing strategies, making a significant impact on business expansion and brand development.",
    },
    {
      name: "Mr. Francis Tan",
      image: "url(/francis.png)",
      title: "Mr. Francis Tan",
      subtitle: "Vice President, Marketing",
      bio: "Mr. Francis Tan is a senior marketing professional with over 25 years of experience in strategic planning, interactive development, and direct marketing. With a strong ability to drive creative and innovative marketing strategies, he brings enthusiastic and forward-thinking leadership to dynamic team environments. Currently leading the marketing division for China, the Philippines, and Indonesia, Mr. Tan specializes in market expansion, brand positioning, and customer engagement strategies across diverse international markets. His expertise in developing high-impact marketing campaigns and driving business growth makes him a key force in the company's global marketing initiatives.",
    },
    {
      name: "Mr. Sanjay Gandhi",
      image: "url(/sanjay.png)",
      title: "Mr. Sanjay Gandhi",
      subtitle: "Director, International Projects",
      bio: "Mr. Sanjay Gandhi is a seasoned industry leader with extensive experience in supply chain management, technology-driven transformation, operations strategy, and business development. With a career spanning top management roles at FedEx and DHL across the Asia-Pacific region, as well as Bajaj Auto and L&T in India, he brings a wealth of expertise in logistics, operations, and strategic growth initiatives. In addition to his corporate leadership, Mr. Gandhi is a part-time faculty member at Nanyang Technological University, Singapore, where he shares his industry insights with aspiring professionals. He also serves as a mentor and advisor to startups in Healthcare, Logistics, and Technology, supporting their business development, go-to-market strategies, and operational rollouts. With his deep industry knowledge and global experience, Mr. Gandhi plays a key role in driving international projects, strategic expansion, and operational excellence for the organization.",
    },
    {
      name: "Mr. Sachin D. Agrawal",
      image: "url(/sachin.png)",
      title: "Mr. Sachin D. Agrawal",
      subtitle: "Director, Head of Marketing",
      bio: "Mr. Sachin D. Agrawal is a seasoned professional in Pharma Marketing with over 15 years of experience in the pharmaceutical industry. A Pharmacy graduate from Poona College of Pharmacy, he has worked in pharmaceutical manufacturing units and is an approved competent person for the tablet section. Throughout his career, he has held various leadership positions in renowned pharmaceutical companies, driving strategic marketing initiatives and business growth. In addition to his expertise in pharmaceutical marketing, he has been a Director at a Critical Care & Trauma Centre, showcasing his deep understanding of the healthcare sector. Mr. Agrawal is also well-versed in the financial sector, having served as a Director in investment firms such as Gandhish Brokers LLP. He currently holds the position of Director (Marketing) at Omni Orthotechnics Pvt. Ltd., where he specializes in providing innovative business solutions to drive growth and market expansion. With his extensive experience in healthcare, finance, and marketing, Mr. Agrawal plays a key role in shaping business strategies and delivering impactful marketing solutions.",
    },
  ];

  const cards = [
    {
      title: "Our Vision",
      image: "url(/vision.png)",
      description:
        "To transform healthcare by enabling patients to high quality healthcare services via our technology-enabled platform",
    },
    {
      title: "Our Vision",
      image: "url(/vision.png)",
      description:
        "To empower every individual with seamless access to preventive and personalized healthcare by integrating advanced technology, smart health solutions, and holistic wellness practices—creating a connected, inclusive, and healthier world.",
    },
  ];

  const advisoryTeam = [
    {
      name: "Dr. S. Arulrhaj",
      image: "/arhulraj.png",
      subtitle: "Eminent Physician & Healthcare Visionary",
    },
    {
      name: "Rajanikant M. Torgal",
      image: "/rajanikant.png",
      subtitle: "Tech entrepreneur with 30+ years in global product innovation Medical & Technology Advisors Across India, Singapore, and Canada",
    },
  ];

  return (
    <div className="w-full space-y-10">
      {/* Banner Section */}
      <div
        className="relative w-full h-[600px] bg-cover bg-center flex items-end justify-center pb-8"
        style={{ backgroundImage: "url(service-back.jpg)" }}
      >
        <div className="absolute inset-0 bg-white opacity-20"></div>
        <h1 className="relative text-4xl md:text-5xl font-['Poppins'] z-10">
          About Us
        </h1>
      </div>

      {/* Main Content */}
      <div className="w-full max-w-[1321px] mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-16">
        {/* Our Story Section */}
        <div className="relative w-full flex flex-col items-center space-y-6">
          <button className="flex items-center justify-center px-5 py-2 text-lg sm:text-xl font-bold text-[#02BE0F] font-['Inria_Sans'] border border-[#02BE0F] rounded-full hover:bg-[#02BE0F] hover:text-white transition-colors">
            About Us
          </button>
          <h2 className="text-3xl sm:text-4xl font-bold text-black font-['Inria_Serif'] text-center">
            Our Story
          </h2>
          <p className="max-w-[1268px] text-lg sm:text-xl font-normal text-black font-['Inria_Serif'] leading-9 text-center">
            LifeOnPlus was founded with a bold vision: to bridge the gap between healthcare and everyday accessibility. Born out of real-world experiences in global healthcare and technology sectors, our platform brings preventive diagnostics, non-invasive therapies, smart health access, and AI-driven insights to users through a unified digital ecosystem. We aim to redefine wellness by putting proactive, affordable, and intelligent healthcare in everyone’s hands—urban and rural alike.
          </p>
        </div>

        {/* Our Mission Section */}
        <div className="relative w-full min-h-[529px]">
          <h2 className="w-full max-w-[211px] mx-auto text-3xl md:text-4xl font-medium text-black font-['Poppins'] text-center mb-20">
            Our Mission
          </h2>
          <div className="relative w-full flex flex-col md:flex-row justify-center gap-6 md:gap-12">
            {cards.map((card, index) => (
              <div
                key={index}
                className="relative w-full max-w-[534px] min-h-[392px] bg-[#D2FFD5] rounded-2xl shadow-[0_1px_3px_rgba(0,0,0,0.15)] flex flex-col items-center"
              >
                <div className="relative w-full max-w-[439px] min-h-[235px] mt-12 px-4">
                  <div className="relative w-full max-w-[95px] min-h-[108px] mx-auto">
                    <div
                      className="w-16 h-16 bg-cover bg-center mx-auto"
                      style={{ backgroundImage: card.image }}
                    ></div>
                    <h3 className="w-full max-w-[95px] text-xl font-bold text-[#1A2942] font-['Lato'] text-center mt-4">
                      {card.title}
                    </h3>
                  </div>
                  <p className="w-full text-lg font-normal text-[#1A2942] font-['Inria_Sans'] leading-8 text-center mt-8">
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Founder's Message Section */}
        <div className="relative w-full bg-white rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.15)] py-12 px-4 sm:px-6 lg:px-8">
          <div className="relative w-full max-w-[1214px] mx-auto flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-12">
            {/* Image Section */}
            <div className="relative w-full max-w-[445px] flex-shrink-0 flex justify-center items-center">
              <div className="relative w-full max-w-[354px] h-[358px]">
                {/* Background Rectangles */}
                <div
                  className="absolute w-full h-full border-2 border-[#FF8500] rounded-xl"
                  style={{ right: "-10%", top: "-10%", zIndex: 1 }}
                ></div>
                <div
                  className="absolute w-full h-full border-2 border-[#FF8500] rounded-xl"
                  style={{ right: "10%", top: "10%", zIndex: 1 }}
                ></div>
                {/* Image */}
                <div
                  className="absolute w-[319px] h-[341px] bg-cover bg-center rounded-[70px] left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2"
                  style={{ backgroundImage: "url(/rajanikant.png)", zIndex: 2 }}
                ></div>
              </div>
            </div>
            {/* Text Section */}
            <div className="relative w-full flex flex-col items-center lg:items-start text-center lg:text-left">
              <h2 className="text-3xl sm:text-4xl font-medium text-black font-['Poppins'] mb-8">
                Founder’s Message
              </h2>
              <p className="w-full max-w-[714px] text-lg sm:text-xl font-normal text-[#494949] font-['Poppins'] text-start leading-8 mb-8">
                “The idea of LifeOnPlus was born during my journey across continents where I witnessed how technology could transform lives—but also how healthcare remained inaccessible for many. My goal was to create something that not only healed but empowered. With decades of experience in tech and wellness, LifeOnPlus is my commitment to a healthier tomorrow—driven by purpose, backed by innovation.”
              </p>
              <div className="w-full max-w-[252px] space-y-2">
                <h3 className="text-2xl font-medium text-black font-['Poppins']">
                  Rajanikant M. Torgal,
                </h3>
                <p className="text-start font-normal text-black font-['Poppins'] leading-8">
                  Founder & CEO, LifeOnPlus
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Advisory Board & Team Section */}
        <div className="w-full">
          <div className="relative w-full max-w-[1321px] mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center space-y-8 py-12">
            <h2 className="text-3xl sm:text-4xl font-medium text-black font-['Poppins'] text-center">
              Advisory Board & Team
            </h2>
            <p className="max-w-[818px] text-lg sm:text-xl font-normal text-black font-['Inria_Serif'] leading-9 text-center">
              Our strength lies in a diverse team of medical experts, technologists, wellness leaders, and public health professionals. The LifeOnPlus advisory board guides us in strategy, innovation, and scalable impact.
            </p>
            <button className="flex items-center justify-center px-4 py-2 text-lg font-normal text-black font-['Inria_Serif'] border border-[#FF8500] rounded-full hover:bg-[#FF8500] hover:text-white transition-colors">
              Key Members
            </button>
            <div className="w-full flex flex-col lg:flex-row justify-center gap-6 sm:gap-8 lg:gap-10">
              {advisoryTeam.map((member, index) => (
                <div
                  key={index}
                  className="relative w-full max-w-[372px] bg-[#FAFAFA] rounded-lg shadow-md flex flex-col items-center"
                >
                  <div className="relative w-full max-w-[279px] mt-6">
                    <img
                      src={member.image}
                      alt={`Portrait of ${member.name}`}
                      className="w-full h-[279px] object-cover rounded-lg"
                    />
                  </div>
                  <div className="w-full max-w-[335px] text-center space-y-2 py-4">
                    <h3 className="text-lg sm:text-xl font-medium text-black font-['Poppins']">
                      {member.name}
                    </h3>
                    <p className="text-sm sm:text-base font-normal text-[#2A2A2A] font-['Poppins'] leading-6">
                      {member.subtitle}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Profile Sections */}
        {sections.map((section, index) => (
          <div
            key={index}
            className={`relative w-full flex flex-col ${
              index % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"
            } gap-8 items-center border border-gray-200 rounded-2xl shadow-md p-6`}
          >
            <div className="relative w-full lg:w-[335px] flex-shrink-0 flex items-center justify-center">
              <div
                className="w-full max-w-[335px] h-[357px] bg-cover bg-center rounded-2xl"
                style={{ backgroundImage: section.image }}
              ></div>
            </div>
            <div className="relative w-full lg:w-[920px] space-y-4">
              <h2 className="w-full max-w-[280px] text-2xl font-bold text-black font-['Poppins']">
                {section.title}
              </h2>
              <h3 className="w-full max-w-[350px] text-xl font-medium text-black font-['Poppins']">
                {section.subtitle}
              </h3>
              <p className="w-full text-base font-normal text-[#363636] font-['Poppins'] leading-[33px]">
                {section.bio}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default About;